import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  inject,
  Input,
  OnInit,
  SecurityContext,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';

import { ViewportService } from '@digital-platform/rs-shared/services';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';

interface RichTextAngularConfig {
  style?: string;
  mobileStyle?: string;
  midsizeStyle?: string;
  desktopStyle?: string;
  class?: string;
  mobileClass?: string;
  midsizeClass?: string;
  desktopClass?: string;
}

@Component({
  selector: 'digital-platform-rsx-rich-text',
  template: '',
  styleUrls: ['./rich-text.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class RichTextComponent
  extends BasePTypeComponent
  implements AfterViewInit, OnInit
{
  public override type = 'richText' as const;
  public viewportService = inject(ViewportService);

  @HostBinding('class') className?: string;
  @HostBinding('style') inlineStyle?: string;

  @Input() public body = '';
  @Input() public angularConfig?: RichTextAngularConfig;

  public dynamicComponentOutput = new Subject();

  constructor(private elementRef: ElementRef, private sanitizer: DomSanitizer) {
    super();
  }

  ngOnInit() {
    this.viewportService.whatViewport$.subscribe(() => {
      this.initClassesAndStyles();
    });
  }

  public ngAfterViewInit(): void {
    //TODO: remove this when the `a` tag is coming as `rsx-a` in cms richText is fixed.
    this.body = this.body ? this.body.replace(/rsx-a/g, 'a') : '';
    this.elementRef.nativeElement.innerHTML = this.sanitizer.sanitize(
      SecurityContext.NONE,
      this.body
    );
    this.initClassesAndStyles();
  }

  private initClassesAndStyles() {
    const cls = [];
    let styles = '';
    if (this.angularConfig) {
      const { isMobile, isMidsize, isDesktop } = this.viewportService;
      const {
        class: angClass,
        mobileClass,
        desktopClass,
        midsizeClass,
        style,
        mobileStyle,
        midsizeStyle,
        desktopStyle,
      } = this.angularConfig;

      cls.push(
        angClass,
        isMobile && mobileClass,
        isMidsize && midsizeClass,
        isDesktop && desktopClass
      );

      if (style) styles += style;
      if (isMobile && mobileStyle) {
        styles += ' ' + mobileStyle;
      } else if (isMidsize && midsizeStyle) {
        styles += ' ' + midsizeStyle;
      } else if (isDesktop && desktopStyle) {
        styles += ' ' + desktopStyle;
      }
    }
    this.className = cls.filter((c) => c).join(' ');
    this.inlineStyle = styles;
  }

  public ngOnDynamicInstanceRendered(): void {
    this.dynamicComponentOutput.next({ ready: true, unsubscribe: true });
  }
}
